module.exports = __webpack_public_path__ + "static/media/bg8.eb4ec7f6.jpg";